module.exports = "<app-master-menu></app-master-menu>\r\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/masters/masters.component.html
// module id = ./src/app/masters/masters.component.html
// module chunks = main